export const USER_SIGNUP_TERMS_ACKNOWLEDGEMENT =
  'USER_SIGNUP_TERMS_ACKNOWLEDGEMENT';
export const USER_COMMENT_TOOLTIP_ACKNOWLEDGEMENT =
  'USER_COMMENT_TOOLTIP_ACKNOWLEDGEMENT';
